module.exports = "//public.getcloudapp.com/packs/media/images/zight-logo-160-36-73e398965bc25b207062fac3115270d4.svg";